import React from 'react';
import { identity } from 'ramda';
import Overlay from 'js/components/common/Overlay';
import { ShallowPopup } from './ShallowPopup';

import style from './Popup.scss';

export const LocalPopup = (props) => {
    // there's no default onClose handler for local popup, since it's managed by parent component.
    const { onClose, onOverlayClick = onClose, classNames = {}, isModal } = props;

    return (
        <div className={`${style.container} ${classNames.container || ''}`}>
            <Overlay className={`${classNames.overlay || ''}`} onClick={isModal ? identity : onOverlayClick} />
            <ShallowPopup {...props} />
        </div>
    );
};
